import React, { useState } from 'react';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import SarasButton from '../../../../library/input/buttons/button/SarasButton';
import WorkflowLink from './WorkflowLink';

const formatDate = (value) => {
    if (!value) return "";

    try {
        return new Date(value).toLocaleString();
    } catch (e) {
        return value;
    }
};

const getStageMeta = (stage) => {
    // const formatter = stage?.viewFormatter?.stageKey || {};

    return {
        label: stage?.stageLabel || stage?.stageKey || ''
    };
};

const getActionIconMeta = (action) => {
    const formatter = action?.viewFormatter?.starIcon || {};

    return {
        key: formatter?.label || '',
        className: formatter?.className || ''
    };
};

const getStepperNodeClass = (stage, isCurrent) => {
    if (stage?.state === 'current' || isCurrent) {
        return 'uiWorkflowStepperNode uiWorkflowStageCurrent';
    }

    if (stage?.state === 'completed') {
        return 'uiWorkflowStepperNode uiWorkflowStageCompleted';
    }

    return 'uiWorkflowStepperNode uiWorkflowStagePending';
};

const getStepperLineClass = (stage) => {
    if (stage?.state === 'completed') {
        return 'uiWorkflowStepperLine uiWorkflowLineCompleted';
    }

    return 'uiWorkflowStepperLine';
};

const getStageRowClass = (stage, isCurrent) => {
    const classList = ['uiWorkflowStage'];

    if (stage?.state === 'current' || isCurrent) {
        classList.push('uiWorkflowStageRowCurrent');
    }
    else if (stage?.state === 'completed') {
        classList.push('uiWorkflowStageRowCompleted');
    }
    else {
        classList.push('uiWorkflowStageRowPending');
    }

    return classList.join(' ');
};

const renderLogs = (logList) => {
    if (!Array.isArray(logList) || logList.length === 0) {
        return (
            <div className="uiWorkflowStageEmptyLog">
                <SarasTrans value="No logs in this stage" />
            </div>
        );
    }

    return (
        <ul className="uiWorkflowStageLogs">
            {logList.map((log, index) => (
                <li key={log?.logId || index} className="uiWorkflowStageLogItem">
                    <div className="uiWorkflowStageLogMeta">
                        {formatDate(log?.logDate)}
                        {log?.createdBy ? ` | ${log.createdBy}` : ''}
                    </div>
                    {log?.title ? (
                        <div className="uiWorkflowStageLogTitle">{log.title}</div>
                    ) : null}
                    {log?.message ? (
                        <div className="uiWorkflowStageLogMessage">{log.message}</div>
                    ) : null}
                </li>
            ))}
        </ul>
    );
};

const splitStageActions = (actionList) => {
    const result = {
        linkActions: [],
        buttonActions: []
    };

    if (!Array.isArray(actionList)) {
        return result;
    }

    actionList.forEach((action) => {
        if (action?.renderMode === 'link') {
            result.linkActions.push(action);
        }
        else {
            result.buttonActions.push(action);
        }
    });

    return result;
};

const WorkflowStages = ({ formObject, workflowView, currentStageRef }) => {
    const [openHelpKey, setOpenHelpKey] = useState('');
    const stageList = workflowView?.stageList || [];

    const onHelpToggle = (stageKey) => {
        setOpenHelpKey(prev => prev === stageKey ? '' : stageKey);
    };

    const onWorkflowActionClick = (stage, action) => {
        if (!action?.isEnabled) {
            return;
        }

        if(action.requireComment){
            // console.log('workflowAction', { stage, action });
            let customAction = {containerKey: "popup"};

            customAction.actionId = action.actionId;
            customAction.refreshMode = "dep";
            customAction.actionName = action.actionName;
            let actionParam = formObject.convertStrToKeyValue(action.actionParam)
            customAction.actionParam = {...actionParam, isint: "0", 
                                        actionType: action.actionType };


            // console.log('workflowAction', { stage, action, customAction });

            //trigger the api request
            formObject.onFormAction(customAction, "", "");
        }
        else{
            // console.log('workflowAction', { stage, action });
            let customAction = {};

            customAction.actionId = action.actionId;
            customAction.actionName = action.actionName;
            let actionParam = formObject.convertStrToKeyValue(action.actionParam);
            customAction.actionParam = {...actionParam, 
                                        actionType: action.actionType };


            // console.log('workflowAction', { stage, action, customAction });

            //trigger the api request
            formObject.onFormAction(customAction, "", "");
        }
    };

    return (
        <div className="uiWorkflowStageList">
            {stageList.map((stage, index) => {
                const stageMeta = getStageMeta(stage);
                const isCurrent = workflowView?.currentStageKey === stage?.stageKey;
                const showHelp = !!stage?.actionDescription;
                const isHelpOpen = isCurrent || openHelpKey === stage?.stageKey;
                const stepperNodeClass = getStepperNodeClass(stage, isCurrent);
                const stepperLineClass = getStepperLineClass(stage);
                const stageRowClass = getStageRowClass(stage, isCurrent);
                const stageActions = splitStageActions(stage?.actionList);

                return (
                    <div
                        key={stage?.stageKey || index}
                        ref={isCurrent ? currentStageRef : null}
                        className={stageRowClass}
                    >
                        <div className="uiWorkflowStageStepper">
                            <div className={stepperNodeClass}>
                                {stage?.state === 'completed' ? '✓' : ''}
                            </div>
                            {index < stageList.length - 1 ? (
                                <div className={stepperLineClass}></div>
                            ) : null}
                        </div>
                        <div className="uiWorkflowStageCard">
                            <div className="uiWorkflowStageHeader">
                                <div className="uiWorkflowStageTitleRow">
                                    <div className="uiWorkflowStageTitle">{stageMeta.label}</div>
                                    {showHelp ? (
                                        <SarasButton
                                            onlyIcon={true}
                                            starIcon="help"
                                            className="uiActionIconButton uiWorkflowStageHelp"
                                            starIconClassName="uiLink uiIcon"
                                            tooltip="Stage Help"
                                            onClick={() => onHelpToggle(stage?.stageKey)}
                                        />
                                    ) : null}
                                </div>
                            </div>
                            {renderLogs(stage?.logList)}
                            {showHelp && isHelpOpen ? (
                                <div className="uiWorkflowStageHelper">
                                    <SarasTrans value={stage?.actionDescription || ''} />
                                </div>
                            ) : null}
                            {stageActions.linkActions.length > 0 ? (
                                <div className="uiWorkflowStageLinks">
                                    {stageActions.linkActions.map((action, actionIndex) => (
                                        <React.Fragment key={`${stage?.stageKey || index}-link-${action?.actionType || actionIndex}`}>
                                            <WorkflowLink action={action} formObject={formObject} />
                                        </React.Fragment>
                                    ))}
                                </div>
                            ) : null}
                            {stageActions.buttonActions.length > 0 ? (
                                <div className="uiWorkflowStageActions">
                                    {stageActions.buttonActions.map((action, actionIndex) => (
                                        (() => {
                                            const iconMeta = getActionIconMeta(action);

                                            console.log("stageActions", action, actionIndex, iconMeta);

                                            return (
                                                <React.Fragment key={`${stage?.stageKey || index}-${action?.actionType || actionIndex}`}>
                                                    <SarasButton
                                                        className={action?.isPrimary ? 'uiPrimaryAction' : 'uiSecondaryAction'}
                                                        starIcon={iconMeta.key}
                                                        starIconClassName={iconMeta.className}
                                                        disabled={!action?.isEnabled}
                                                        onClick={() => onWorkflowActionClick(stage, action)}
                                                    >
                                                        <SarasTrans value={action?.actionLabel || ''} />
                                                    </SarasButton>
                                                    {!action?.isEnabled && action?.requiredPrivilegeLabel ? (
                                                        <div className="uiWorkflowStageActionPermission">
                                                            <SarasTrans value={`Permissions: ${action.requiredPrivilegeLabel}`} />
                                                        </div>
                                                    ) : null}
                                                </React.Fragment>
                                            );
                                        })()
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default WorkflowStages;
